function getCircumference(radius: number): number {
  return 2 * Math.PI * radius;
}

export { getCircumference };
